module.exports = __webpack_public_path__ + "static/media/logo-laxarxa.77f19d13.svg";